<template>
  <drawer-layout>
    <main class="bible">
      <control-panel
        :breadcrumbs="itemsBreadcrumbs"
        title="Configuraciones"
      />
      <v-form>
        <span class="label">URL Drive</span>
        <v-row>
            <v-text-field
              v-model="drive"
              class="input-text body-text drive-input"
              dense
              flat
              solo
              outlined
              required
            ></v-text-field>
            <v-btn class="primary" @click="save({id: url[0].id, url: drive})">Guardar</v-btn>
        </v-row>
      </v-form>
    </main>
  </drawer-layout>
</template>

<script>
import { mapActions } from 'vuex';
import DrawerLayout from "../../Shared/DrawerLayout.vue";
import ControlPanel from "@/Shared/ControlPanel.vue";
export default {
  components: {
    DrawerLayout,
    ControlPanel,
  },
  props: {
    url: {
      type: Array,
      default: []
    }
  },
  mounted(){
    this.drive = this.url[0].url;
  },
  data() {
    return {
      valid: false,
      drive: "https://drive.google.com/drive/u/0/my-drive",
      itemsBreadcrumbs: [
        {
          text: "Orígenes de datos",
          disabled: false,
          href: "/",
        },
        {
          text: "configuraciones",
          disabled: true,
          href: "/",
        },
      ],
    };
  },
  methods:{
    ...mapActions({
      save: 'configuration/setUrl'
    })
  }
};
</script>

<style scoped>
</style>
